function numberFormat(n, options) {
	let {thousandSeparator = ".", decimalSeparator = ",", decimalPlaceholder = false} = options || {};

	if (typeof n !== "number") {
		return null;
	}

	let whole = parseInt(n);
	let decimals = parseInt((n - whole) * 100);

	// Parse whole number
	let wholePrefixSize = whole.toString().length % 3;
	let wholePrefix = wholePrefixSize > 0 ? whole.toString().substr(0, wholePrefixSize) : "";
	let wholeSuffix = [];
	let wholeRest = whole.toString().substr(wholePrefixSize);

	while (wholeRest.length > 0) {
		wholeSuffix.push(wholeRest.substr(0, 3));
		wholeRest = wholeRest.substr(3);
	}

	let wholeParts = [];

	if (wholePrefix.length > 0) {
		wholeParts.push(wholePrefix);
	}

	if (wholeSuffix.length > 0) {
		wholeParts.push(wholeSuffix.join("."));
	}

	whole = wholeParts.join(thousandSeparator);

	// Parse decimals
	if (decimals > 0) {
		decimals = decimalSeparator + (decimals.toString().length < 2 ? decimals.toString() + "0" : decimals.toString());
	}
	else {
		decimals = typeof decimalPlaceholder === "string" ? decimalSeparator + decimalPlaceholder : "";
	}

	return whole + decimals;
}

function moneyFormat(n, options) {
	let {currency = "DKK", ...opts} = options || {};
	const value = numberFormat(n, opts);
	return typeof currency === "string" ? `${value} ${currency}` : `${value}`;
}

function enumerateWithRest(elements, max = 2) {
	const extras = Math.min(elements.length - max, 0);
	return elements.slice(0, max).join(", ") + (extras > 0 ? ` +${extras}` : "");
}

function roundToFives(n) {
	const division = n / 5;
	const whole = Math.floor(division);
	const rest = Math.round(division - whole);

	return (whole + rest) * 5;
}

module.exports = {
	numberFormat,
	moneyFormat,
	enumerateWithRest,
	roundToFives
};


// WEBPACK FOOTER //
// ./resources/js/helpers/format.js